module.exports = __webpack_public_path__ + "static/img/manual-34.b9c69da.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-34.png
// module id = qmSW
// module chunks = 4